import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/briefcase.vue
var o = {
	name: "DtIconBriefcase",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--briefcase"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Briefcase",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M3.94 1.44A1.5 1.5 0 0 1 5 1h2a1.5 1.5 0 0 1 1.5 1.5V3H10a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 10 11H2A1.5 1.5 0 0 1 .5 9.5v-5A1.5 1.5 0 0 1 2 3h1.5v-.5c0-.398.158-.78.44-1.06ZM3.5 4H2a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h1.5V4Zm1 6V4h3v6h-3Zm4 0H10a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 10 4H8.5v6Zm-1-7h-3v-.5A.5.5 0 0 1 5 2h2a.5.5 0 0 1 .5.5V3Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=briefcase.js.map